module.exports = __webpack_public_path__ + "files/e503234802060ec86a8c8575d5d0036f.png";